import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Radio } from 'antd';

import withFieldWrapper from '../hocs/withFieldWrapper';

class CheckboxComponent extends Component {
    static propTypes = {
        input: PropTypes.object,
        text: PropTypes.string,
        onChange: PropTypes.func
    };

    onChange = e => this.props.onChange(e.target.value);

    render() {
        const { input: { value, name }, text, t } = this.props;

        return (
            <div>
                <p>
                    <label>{text}</label>
                </p>
                <Radio.Group name={name} onChange={this.onChange} value={value}>
                    <Radio value={true} id='yes'>
                        {t('radioYes')}
                    </Radio>
                    <Radio value={false} id='no'>
                        {t('radioNo')}
                    </Radio>
                </Radio.Group>
            </div>
        )
    }
}

export default withFieldWrapper(withTranslation()(CheckboxComponent));
